import React, { useState, useEffect } from "react";
import ScrollToTop from "@/components/ScrollTop";
import Banner from "@/components/Banner";

import "bootstrap/dist/css/bootstrap-grid.min.css";

import { Container } from "./styles";

export const About = () => {
	let [iframe, setIframe] = useState(1);

	function debounce(fn, ms) {
		let timer;
		return (_) => {
			clearTimeout(timer);
			timer = setTimeout((_) => {
				timer = null;
				fn.apply(this, arguments);
			}, ms);
		};
	}

	// frist handle
	useEffect(() => {
		if (window.innerWidth >= 992) {
			setIframe(1);
		} else {
			setIframe(0);
		}
	}, []);

	// handle resize
	useEffect(() => {
		const debouncedHandleResize = debounce(function handleResize() {
			if (window.innerWidth >= 992) {
				setIframe(1);
			} else {
				setIframe(0);
			}
		}, 1000);

		window.addEventListener("resize", debouncedHandleResize);

		return (_) => {
			window.removeEventListener("resize", debouncedHandleResize);
		};
	});

	return (
		<React.Fragment>
			<ScrollToTop />
			<Container>
				<Banner
					text='Sobre Gerioox'
					img={require("@/assets/img/foto3@3x.png").default}
				/>

				<section className='container'>
					<div className='row justify-content-lg-center'>
						<div className='col-12 col-lg-10'>
							<div className='content'>
								<h2 className='title'>
									Pets com{" "}
									<span className='text-primary'>
										grandes histórias
									</span>
								</h2>

								<div className='video'>
									<iframe
										loading='lazy'
										title={"video1"}
										style={{
											display:
												iframe === 1 || iframe === 0
													? "block"
													: "none",
										}}
										width='930'
										height='520'
										src='https://www.youtube.com/embed/XpBGtAyBz98'
										frameBorder='0'
										allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
										allowFullScreen></iframe>
									<iframe
										loading='lazy'
										title={"video2"}
										style={{
											display:
												iframe === 2 || iframe === 0
													? "block"
													: "none",
										}}
										width='930'
										height='520'
										src='https://www.youtube.com/embed/R7WarK0p7UQ'
										frameBorder='0'
										allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
										allowFullScreen></iframe>
									<iframe
										loading='lazy'
										title={"video3"}
										style={{
											display:
												iframe === 3 || iframe === 0
													? "block"
													: "none",
										}}
										width='930'
										height='520'
										src='https://www.youtube.com/embed/3uo1s4EfkJU'
										frameBorder='0'
										allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
										allowFullScreen></iframe>
								</div>

								<div className='videos'>
									<ul>
										<li onClick={() => setIframe(1)}>
											<img
												loading='lazy'
												className='img-responsive'
												src={
													require("@/assets/img/video1.jpg")
														.default
												}
												alt='video 1'
											/>
										</li>
										<li onClick={() => setIframe(2)}>
											<img
												loading='lazy'
												className='img-responsive'
												src={
													require("@/assets/img/video2.png")
														.default
												}
												alt='video 2'
											/>
										</li>
										<li onClick={() => setIframe(3)}>
											<img
												loading='lazy'
												className='img-responsive'
												src={
													require("@/assets/img/video3.png")
														.default
												}
												alt='video 3'
											/>
										</li>
									</ul>
								</div>

								<h2 className='title m-text-center desktop-text'>
									Mais saudável,{" "}
									<span className='text-primary'>
										célula a célula
									</span>
								</h2>

								<p className='m-text-center'>
									Gerioox cuida de todas as células do seu pet
									e essa proteção se estende a todo o
									organismos, proporcionando o máximo
									bem-estar.
								</p>

								<img
									loading='lazy'
									className='img-responsive mb-5'
									src={
										require("@/assets/img/cao-e-gato-geriox.jpg")
											.default
									}
									alt='video 1'
								/>

								<a
									className='btn-secundary center'
									href='//www.gerioox.com'
									target='_blank'
									rel='noreferrer'>
									saiba mais sobre gerioox
								</a>
							</div>
						</div>
					</div>
				</section>
			</Container>
		</React.Fragment>
	);
};

export default About;
